import React, { Component } from 'react'
import { PropTypes as T } from 'prop-types'
import { connect } from 'react-redux'

import ToggleWithLabel from './ToggleWithLabel'
import { followTopic, unfollowTopic } from '../store/actions/topicFollowActions'

class TopicFollowButton extends Component {
  static propTypes = {
    currentUser: T.object,
    dispatch: T.func.isRequired,
    followersCount: T.number,
    following: T.bool,
    href: T.string.isRequired,
    slug: T.string.isRequired,
  }

  render() {
    return (
      <div className="btn btn-small border rounded">
        <ToggleWithLabel
          iconOff="plus"
          iconOn="check"
          labelOff="Follow"
          labelOn="Following"
          on={this.props.following}
          onClick={this.handleClick} />
      </div>
    )
  }

  handleClick = () => {
    const action = this.props.following ? unfollowTopic : followTopic
    this.props.dispatch(
      action(this.props.href, this.props.slug, this.props.followersCount)
    )
  }
}

function mapStateToProps(state, ownProps) {
  const topicFollows = state.topicFollows || { items: [], counts: {} }
  const items = topicFollows.items || []
  const counts = topicFollows.counts || {}
  const following = items.indexOf(ownProps.slug) > -1
  const followersCount = Object.prototype.hasOwnProperty.call(counts, ownProps.slug)
    ? counts[ownProps.slug]
    : ownProps.followersCount

  return {
    currentUser: state.currentUser && state.currentUser.item,
    following,
    followersCount,
  }
}

export default connect(mapStateToProps)(TopicFollowButton)
